module.exports = __webpack_public_path__ + "img/cawthron_logo.8a883eb4.svg";